// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const deferDispatch = require('client-v2/common/state/dispatch')
// Container imports
const feedSelectors = require('../feed/selectors')
const profileUserActions = require('../profile-user/actions')
const UserProfileContentNav = require('./component-dumb')

function mapStateToProps(state) {
  const isSelfProfile = feedSelectors.isSelfProfileState(state)
  return {
    isHidden: !isSelfProfile && feedSelectors.isItemsEmptyState(state),
    collectionsNavSelected: collectionsNavSelectedState(state),
    primaryNavSelected: primaryNavSelectedState(state),
    profileUser: state.profileUser,
    profileUserStats: state.profileUserStats
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    onCollectionsClick: dispatchAction(profileUserActions.navigateToUserProfileCollections),
    onCollectionsCreatedClick: dispatchAction(profileUserActions.navigateToUserProfileCollectionsCreated),
    onCollectionsSubscribedClick: dispatchAction(profileUserActions.navigateToUserProfileCollectionsSubscribed),
    onPostsClick: dispatchAction(profileUserActions.navigateToUserProfilePosts)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    UserProfileContentNav
  )
)

function collectionsNavSelectedState(state) {
  switch (state.router.action) {
    case 'user-profile.showCollectionsCreated':
      return 'created'
    case 'user-profile.showCollectionsSubscribed':
      return 'subscribed'
    default:
      return null
  }
}

function primaryNavSelectedState(state) {
  switch (state.router.action) {
    case 'user-profile.showCollectionsCreated':
    case 'user-profile.showCollectionsSubscribed':
      return 'collections'
    case 'user-profile.showPosts':
      return 'posts'
    default:
      return null
  }
}
